import { forwardRef, HTMLAttributes } from 'react'
import cn from 'classnames'
import styles from './StatusPill.module.scss'

export type StatusPillTone = 'neutral' | 'info' | 'success' | 'warning' | 'error' | 'purple'

interface IProps extends HTMLAttributes<HTMLSpanElement> {
  tone: StatusPillTone
  size?: 'small' | 'medium'
  'data-cy'?: string
}

/** A rounded, tinted status label. Forwards its ref and props so it can sit inside a Tooltip. */
const StatusPill = forwardRef<HTMLSpanElement, IProps>(
  ({ tone, size = 'small', className, children, ...rest }, ref) => (
    <span ref={ref} className={cn(styles.pill, styles[size], styles[tone], className)} {...rest}>
      {children}
    </span>
  ),
)

StatusPill.displayName = 'StatusPill'

export default StatusPill
